// 设置文件
import setting from '@/setting.js'
import api from '@/api'
import router from '@/router'
import { flat } from '@/libs/util'

export default {
  namespaced: true,
  state: {
    allMenu: [],
    menuMap: {},
    // 顶栏菜单
    header: [],
    // 侧栏菜单
    aside: [],
    // 侧边栏收缩
    asideCollapse: setting.menu.asideCollapse,
    // 侧边栏折叠动画
    asideTransition: setting.menu.asideTransition
  },
  actions: {
    /**
     * 设置侧边栏展开或者收缩
     * @param {Object} context
     * @param {Boolean} collapse is collapse
     */
    async asideCollapseSet({ state, dispatch }, collapse) {
      // store 赋值
      state.asideCollapse = collapse
      // 持久化
      await dispatch(
        'admin/db/set',
        {
          dbName: 'sys',
          path: 'menu.asideCollapse',
          value: state.asideCollapse,
          user: true
        },
        { root: true }
      )
    },
    /**
     * 切换侧边栏展开和收缩
     * @param {Object} context
     */
    async asideCollapseToggle({ state, dispatch }) {
      // store 赋值
      state.asideCollapse = !state.asideCollapse
      // 持久化
      await dispatch(
        'admin/db/set',
        {
          dbName: 'sys',
          path: 'menu.asideCollapse',
          value: state.asideCollapse,
          user: true
        },
        { root: true }
      )
    },
    /**
     * 设置侧边栏折叠动画
     * @param {Object} context
     * @param {Boolean} transition is transition
     */
    async asideTransitionSet({ state, dispatch }, transition) {
      // store 赋值
      state.asideTransition = transition
      // 持久化
      await dispatch(
        'admin/db/set',
        {
          dbName: 'sys',
          path: 'menu.asideTransition',
          value: state.asideTransition,
          user: true
        },
        { root: true }
      )
    },
    /**
     * 切换侧边栏折叠动画
     * @param {Object} context
     */
    async asideTransitionToggle({ state, dispatch }) {
      // store 赋值
      state.asideTransition = !state.asideTransition
      // 持久化
      await dispatch(
        'admin/db/set',
        {
          dbName: 'sys',
          path: 'menu.asideTransition',
          value: state.asideTransition,
          user: true
        },
        { root: true }
      )
    },
    /**
     * 持久化数据加载侧边栏设置
     * @param {Object} context
     */
    async asideLoad({ state, dispatch }, funID) {
      if (!state.header || !state.header.length) {
        // store 赋值
        const menu = await dispatch(
          'admin/db/get',
          {
            dbName: 'sys',
            path: 'menu',
            defaultValue: setting.menu,
            user: true
          },
          { root: true }
        )
        state.asideCollapse =
          menu.asideCollapse !== undefined
            ? menu.asideCollapse
            : setting.menu.asideCollapse
        state.asideTransition =
          menu.asideTransition !== undefined
            ? menu.asideTransition
            : setting.menu.asideTransition

        await dispatch('asideHeadLoad')
      }
      await dispatch('asideMenuLoad', funID)
    },
    async asideHeadLoad({ commit, dispatch }) {
      const res = await api.SYS_MENU_SIDE_LOAD('1')
      const headerMenuMap = Object.fromEntries(
        res.body.data.map((m) => [m.funcID, m])
      )
      const headerMenu = res.body.data.map((m) => ({ ...m, children: [] }))

      commit('setAllMenu', res.body.data)
      await dispatch('setMenuMap', res.body.data)
      commit('setHeaderMenuMap', headerMenuMap)
      commit('headerSet', headerMenu)
    },
    async asideMenuLoad({ state, commit, dispatch }, funID) {
      if (!funID) {
        const routeMeta = router.app.$route.meta || {}
        funID = routeMeta.PID
      }
      dispatch('headerActiveSet', funID)
      const headerMenu = state.headerMenuMap[funID] || {}
      commit('asideSet', headerMenu.children || [])
    },
    async headerActiveSet({ dispatch }, funID) {
      if (funID) {
        dispatch(
          'admin/db/set',
          {
            dbName: 'sys',
            path: 'menu.headerActive',
            value: funID,
            user: true
          },
          { root: true }
        )
      }
    },
    async setMenuMap({ commit }, val) {
      const menus = flat(val, 'children')
      commit('setMenuMap', Object.fromEntries(menus.map((t) => [t.funcID, t])))
    },
    clearMenu({ commit }) {
      commit('clearMenu')
    }
  },
  mutations: {
    clearMenu(state) {
      state.allMenu = []
      state.menuMap = {}
      state.header = []
      state.aside = []
    },
    setAllMenu(state, menu) {
      state.allMenu = menu
    },
    setMenuMap(state, menu) {
      state.menuMap = menu
    },
    /**
     * @description 设置顶栏菜单
     * @param {Object} state state
     * @param {Array} menu menu setting
     */
    headerSet(state, menu) {
      // store 赋值
      state.header = menu
    },
    setHeaderMenuMap(state, menu) {
      state.headerMenuMap = menu
    },
    /**
     * @description 设置侧边栏菜单
     * @param {Object} state state
     * @param {Array} menu menu setting
     */
    asideSet(state, menu) {
      // store 赋值
      state.aside = menu
    }
  }
}
